
import React, { useEffect, useState, useRef, useCallback } from 'react';
// import * as API2 from '../STATES';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
// import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
// import { headStyle, hrStyle, buttonStyle, headStyleInverted, backgroundStyle, lightColor, verticalCenter } from '../../css/styling';
import { ReactComponent as MyIcon } from './images/diatomic-logo-clean.svg';
import { motion } from 'framer-motion';


function GradientCircularProgress({ style }) {
    return (
        <React.Fragment>
            <svg style={style}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="30%" x2="80%" y2="100%">

                        {/* <stop offset="0%" stopColor="#115e59" />
                        <stop offset="20%" stopColor="#115e59" />
                        <stop offset="100%" stopColor="black" /> */}

                        <stop offset="0%" stopColor="#f5f5f4" />
                        <stop offset="20%" stopColor="#f5f5f4" />
                        <stop offset="100%" stopColor="black" />

                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress size={40} thickness={2} sx={{ scale: "-16 0.8", 'svg circle': { stroke: 'url(#my_gradient)' } }} />
            <CircularProgress size={40} thickness={1} sx={{ scale: "-6 0.8", 'svg circle': { stroke: 'url(#my_gradient)' } }} />
            {/* <CircularProgress size={20} thickness={2} sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} /> */}
        </React.Fragment>
    );
}

export default function SplashScreen({ children }) {
    return (<Box style={{
        position: 'absolute',
        height: '100vh', width: '100vw',
        // top: 0, left: 0, 
        background: 'rgba(0, 0, 0, 0.95)',
        zIndex: 1000,
        // paddingLeft:'50vw'
        // textAlign: 'center',
        display: 'inline-flex',
        justifyContent: 'center',
        // alignItems: 'center',
        // height: '200px',
        // border: '3px solid green'
        paddingTop: '40vh'

        // line-height: 200px;
        // height: 200px;
        // border: 3px solid green;
        // textAlign: 'center'
    }}>
        {false && <div className='block'>
            <div>{process.env.REACT_APP_MAPBOX_APIKEY}</div>
            <div>{process.env.REACT_APP_GOOGLE_MAPS_API_KEY}</div>
            <div>{process.env.REACT_APP_DEV_API}</div>
            <div>{process.env.REACT_APP_OPENAI_KEY}</div>
            <div>{process.env.REACT_APP_KEYCLOAK_URL}</div>
            <div>{process.env.REACT_APP_KEYCLOAK_REALM}</div>
            <div>{process.env.REACT_APP_KEYCLOAK_CLIENT_ID}</div>
        </div>}

        {/* <div
            dangerouslySetInnerHTML={{ __html: MyIcon }}
        /> */}

        {/* <img
            src={MyIcon}
            // style={{
            //     // marginTop:'-300px',
            //     // marginTop:'-80vh',
            //     position: 'fixed', 
            //     width: '40vh', 
            //     top: '25vh',
            //     // display: 'inline-block',
            //     // verticalAlign: 'middle',
            //     // paddingBottom:'300px'
            //     // left: '50%',
            //     // msTransform: 'translate(-50%, -50%)',
            //     // transform: 'translate(-50%, -50%)',
            //     // objectFit: 'cover', 
            //     // objectPosition: '-20% 0'
            // }}
        /> */}


        <div className="flex flex-col items-center">
            <motion.div
                className="h-[75px] w-[230px] overflow-hidden scale-150 z-50"
                animate={{ y: [0, -20, 0] }} // Moves the element up by 20px and back down
                transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
            >
                <MyIcon className="text-stone-100" />
            </motion.div>

            <motion.div
                className='mt-2 z-50'
                animate={{ y: [0, -20, 0] }} // Moves the element up by 20px and back down
                transition={{ delay: 1, duration: 6, repeat: Infinity, ease: 'easeInOut' }}
            >
                {/* <MyIcon className="text-teal-800" /> */}
                <h2 className='text-[28px] w-full'>
                    CANVAS LOADING
                </h2>
            </motion.div>

            {/* <motion.div
                animate={{ y: [0, -20, 0] }} // Moves the element up by 20px and back down
                transition={{ duration: 1, repeat: Infinity, ease: 'easeInOut' }}
            > */}
            <GradientCircularProgress
                style={{
                    position: 'relative',
                    marginTop: '-14vh',
                    width: '30vw',
                }}
            />
            {/* </motion.div> */}
        </div>



        {children}</Box>)
}